import { Modal } from 'antd'
import { useState } from 'react'
import { Login } from '@/views/Auth'

export const ModalAuth = ({ login, showLogin, onLogin, showGoogle = true, children, onShowOtherLogin }) => {
  const [title, setTitle] = useState('')
  return (
    <Modal
      className="login-modal"
      title={title}
      open={login}
      footer={null}
      onCancel={() => showLogin(false)}
      destroyOnClose={true}
      closable={true}
    >
      {children}
      <Login
        modal={true}
        showGoogle={showGoogle}
        onLogin={onLogin}
        setTitle={setTitle}
        onShowOtherLogin={onShowOtherLogin}
      />
    </Modal>
  )
}
